// extracted by mini-css-extract-plugin
export default {"cls1":"fWR3iJJKnGBkTS2BT77g","cls2":"_BzK4rqpk2hUz3wMKFgg fWR3iJJKnGBkTS2BT77g"};